module.exports = __webpack_public_path__ + "static/media/zahod.e94dfd1a.jpg";